import React from "react";
import {
  Button,
  PanelDialog,
  PanelHeading,
  PanelRow,
  PanelSpacer,
  PanelActions,
  BoldText,
} from "@backslashbuild/pp-ui";
import { useUpdateField } from "./api";
import { publish } from "../../pubSub";
import { useHistory } from "react-router-dom";

function MarkLeadDeadButton({ id }) {
  const history = useHistory();

  // you have to query to see if there are any currently staged pay runs and then disable the button.
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const markLeadAsDead = useUpdateField({ id, formName: "" });

  async function handleSubmit() {
    try {
      const response = await markLeadAsDead({ key: "MarkedDeadLeadAt", value: new Date() });

      if (response.isSuccess) {
        publish("notification", "Marked lead as dead");
        history.replace(`/registrations`);
      } else {
        publish(
          "notification",
          <>
            Unable to mark lead as dead
            <ul>
              {response.errors.map((error) => (
                <li>{error}</li>
              ))}
            </ul>
          </>
        );
      }
    } catch (e) {
      console.error(e, "error marking lead as dead");
      publish("notification", "A network error occured.");
    }
  }

  return (
    <>
      <Button variant="secondary" onClick={() => setDialogOpen(true)} large>
        Mark Lead as Dead
      </Button>
      <PanelDialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <PanelHeading>Mark Lead as Dead</PanelHeading>
        <PanelSpacer large />
        <PanelRow>
          <BoldText>Are you sure you want to mark this lead as dead?</BoldText>
        </PanelRow>
        <PanelSpacer large />
        <PanelActions>
          <Button variant="secondary" onClick={() => setDialogOpen(false)}>
            No, don't mark lead as dead
          </Button>
          <Button onClick={handleSubmit}>Yes, mark lead as dead</Button>
        </PanelActions>
        <PanelSpacer large />
      </PanelDialog>
    </>
  );
}

export default MarkLeadDeadButton;
